// src/pages/Login.jsx

import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { supabase } from "../lib/supabaseClient";
import notify from '../lib/notify';
import { trackLogin } from '../hooks/useAnalytics';
import { Button as FcButton, Input as FcInput } from '../ui';
import { TextField, PasswordField } from '../ui';

export default function Login({ session, userRole, username }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setErrorMessage(""); // Clear previous errors

    const { data, error: signInError } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    if (signInError) {
      setErrorMessage("Email or password is incorrect. Please try again.");
      return;
    }

    const user = data.user;
    if (!user) {
      setErrorMessage("Could not retrieve user after login.");
      return;
    }

    // Track login event
    trackLogin('email');

    const { data: profile, error: profileError } = await supabase
      .from("profiles")
      .select("username")
      .eq("id", user.id)
      .single();

    if (profileError && profileError.code !== "PGRST116") {
      return notify("An error occurred while checking your profile.", 'error');
    }

    if (!profile?.username) {
      navigate("/setup-profile");
    } else {
      navigate("/");
    }
  };

  return (
    <div className="min-h-screen bg-surface-canvas flex flex-col">
      {/* Green ribbon header */}
      <div className="w-full bg-ui-green py-5 px-6 flex items-center">
        <span className="text-white text-xl font-semibold">Footy Coach</span>
      </div>
      <div className="flex flex-1 items-center justify-center">
        <div className="w-full max-w-4xl rounded-lg shadow-md flex flex-col md:flex-row overflow-hidden m-4">
          {/* Left: Login Form */}
          <div role="main" id="fc-main-content" className="flex-1 bg-surface-card flex flex-col justify-center p-8">
            <h1 className="text-3xl font-bold text-black mb-8 text-center md:text-left">Login</h1>
            <form onSubmit={handleLogin} className="space-y-6">
              <TextField label="Email" id="email" name="email" type="email" autoComplete="email" value={email} onChange={e => setEmail(e.target.value)} required error={errorMessage || undefined} />
              <PasswordField label="Password" id="password" name="password" autoComplete="current-password" value={password} onChange={e => setPassword(e.target.value)} required error={errorMessage || undefined} />
              <div className="flex justify-end">
                <Link to="/forgot-password" className="text-action-primary text-sm hover:underline font-semibold">
                  Forgot Password?
                </Link>
              </div>
              <FcButton variant="primary"
                type="submit"
                className="w-full"
              >
                Log in
              </FcButton>
            </form>
            <div className="mt-6 text-center text-black text-base">
              <span>Don't have an account? </span>
              <Link to="/signup" className="text-action-primary font-semibold hover:underline">sign up here</Link>
            </div>     
          </div>
          {/* Right: FC Logo (desktop only) */}
          <div className="hidden md:flex flex-1 items-center justify-center bg-ui-green">
            <span className="text-[10vw] font-bold text-ui-copper select-none">FC</span>
          </div>
        </div>
      </div>
    </div>
  );
}
